import React from "react";
import { string, func } from "prop-types";

import Close from "../../atoms/icons/close";
import TickIcon from "../../atoms/icons/tick";

import "./success-view.m.css";

const SuccessView = ({ text, closeClick }) => {
  if (!text) {
    return null;
  }

  return (
    <div styleName="wrapper" className="success-wrapper">
      <TickIcon />
      <span styleName="message">{text}</span>
      <div styleName="tick-wrapper" onClick={closeClick}>
        <Close color="#2FD072" />
      </div>
    </div>
  );
};

SuccessView.propTypes = {
  text: string,
  closeClick: func
};

export default SuccessView;
